import { Pagination } from 'swiper';
import { SwiperSlide } from 'swiper/react';

import { Field, ImageField, Item, Link, LinkField, Text, withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';

import { ComponentProps } from 'lib/ComponentProps';

import { SwiperComponent, SwiperSlideComponent } from 'src/components/basicContent/_Swiper/Swiper';

import styles from './GroupCallToAction.module.css';

type GroupCallToActionProps = ComponentProps & {
	fields: {
		Title: Field<string>;
		Link: LinkField;
		CallToActions: Item &
			[
				{
					fields: {
						Icon: ImageField;
						Title: Field<string>;
						Description: Field<string>;
						Link: LinkField;
					};
				}
			];
		EnableTransparentBackground: Field<boolean>;
	};
};

export default withDatasourceCheck()<GroupCallToActionProps>(GroupCallToAction);

function GroupCallToAction(props: GroupCallToActionProps): JSX.Element {
	return (
		<section className={`${styles.section} ${!props.fields?.EnableTransparentBackground?.value ? styles.background : ''} cen padYL`}>
			<Text tag="h3" field={props.fields.Title} className={styles.title} />
			{props.fields?.CallToActions && (
				<SwiperComponent
					modules={[Pagination]}
					pagination={{
						clickable: true,
					}}
					spaceBetween={15}
					slidesPerView={1.15}
					breakpoints={{
						600: {
							slidesPerView: 2,
						},
						800: {
							slidesPerView: 3,
						},
						1200: {
							slidesPerView: 4,
						},
					}}
					className={`${styles.slider} maxWidth`}
				>
					{props.fields?.CallToActions.map((slide, index) => (
						<SwiperSlide className={`${styles.slide} ${styles.background} padX padYL rounded`} key={index}>
							<SwiperSlideComponent
								media={slide.fields.Icon}
								title={slide.fields.Title}
								description={slide.fields.Description}
								link={slide.fields.Link}
								buttonColor="white"
							/>
						</SwiperSlide>
					))}
				</SwiperComponent>
			)}

			<Link field={props.fields.Link} className={`${styles.sectionLink} link linkOffset linkHoverWeighted`} />
		</section>
	);
}
